import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const GARAN_LOG_API_NAME: string = 'garan_log';
export const GARAN_LOG_API_ENDPOINT: string = environment.API_BASE_PATH + '/garan-log';

@Injectable({
  providedIn: 'root',
})
export class GaranLogService {
  create(buyer_id: string, admin_email: string): Observable<any> {
    const api_name: string = GARAN_LOG_API_NAME;
    const path: string = `/${buyer_id}`;
    const init = {
      response: true,
      body: { admin_email },
    };
    return from(API.post(api_name, path, init));
  }
}
